import { api, apitest } from '../api.request';

//本月新款上市数据监测
const get1 = function(o) {
        return api.get("/marketing/get1", o)
    }
    //本月新款TOP20预测
const get2 = function(o) {
        return api.get("/marketing/get2", o)
    }
    // 本月新款上市数据监测
const newProductLaunchDataMonitoringThisMonth = function(o) {
        return apitest.get("/newList/newProductLaunchDataMonitoringThisMonth", o)
    }
    //本月上新五大系列销售占比
const salesProportionOfNewFiveSeriesInThisMonth = function(o) {
    return apitest.get("/newList/salesProportionOfNewFiveSeriesInThisMonth", o)
}
export default {
    newProductLaunchDataMonitoringThisMonth,
    salesProportionOfNewFiveSeriesInThisMonth,
    get1,
    get2
}